import React from "react";
import { Sidebar } from "../components/Sidebar";
import { RiskKPIHeader } from "../components/airisk/RiskKPIHeader";
import { AIRiskAlerts } from "../components/airisk/AIRiskAlerts";
import { ChainVisualization } from "../components/airisk/ChainVisualization";
import { RiskTable } from "../components/airisk/RiskTable";
import { RiskIntelligencePanel } from "../components/airisk/RiskIntelligencePanel";
import { DirectorPanel } from "../components/airisk/DirectorPanel";
import { InsightsProvider, useInsights } from "../data/insightsStore";
import { PageHeader, WORKSPACE_SHELL_CLASS } from "../components/ui/PageHeader";
import { Sparkles } from "lucide-react";

function InsightsBody() {
  const { loading, error, data } = useInsights();
  if (loading && !data) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]" data-testid="insights-loading">
        <div className="text-sm flex items-center gap-2" style={{ color: "#64748B" }}>
          <span className="w-2 h-2 rounded-full cf-pulse" style={{ background: "#7C3AED" }} />
          Modelling live transaction risk…
        </div>
      </div>
    );
  }
  if (error) {
    return (
      <div className="rounded-2xl border border-rose-200 bg-rose-50/60 p-6 text-rose-700" data-testid="insights-error">
        Couldn't load insights: {String(error)}
      </div>
    );
  }
  return (
    <>
      <AIRiskAlerts />
      <DirectorPanel />
      <ChainVisualization />
      <RiskTable />
    </>
  );
}

export default function AIInsightsPage() {
  return (
    <InsightsProvider>
      <div className="min-h-screen overflow-x-hidden gp-surface">
        <Sidebar />
        <main className="md:ml-[var(--cf-sidebar-w,300px)] transition-[margin-left] duration-300 ease-out xl:mr-[360px] flex flex-col min-h-screen overflow-x-hidden" data-testid="ai-insights-main">
          <RiskKPIHeader />
          <div className={`${WORKSPACE_SHELL_CLASS} space-y-8`}>
            <PageHeader
              icon={Sparkles}
              title="Insights"
              description="AI-modelled risk signals and chain intelligence across every live transaction."
              testid="insights-header"
            />
            <InsightsBody />
          </div>
        </main>
        <RiskIntelligencePanel />
      </div>
    </InsightsProvider>
  );
}
